<template>
  <div class="loginpage">
    <help-tip ref="helpTipRef"></help-tip>
    <div class="fd-out">
      <div class="fd-in">
        <!-- 登录页面框框  -->
        <div class="fdinner">
          <div class="device-type-fd-cla">
            <div class="out-box-login" v-if="true">
              <div class="buzhou-div">
                <el-steps
                  :active="step"
                  :space="200"
                  align-center
                  :process-status="'wait'"
                >
                  <el-step
                    :title="$t('common.accountVerification')"
                    description=""
                  ></el-step>
                  <!-- <el-step title="重置密码" description=""></el-step> -->
                  <el-step
                    :title="$t('common.fineshed')"
                    description=""
                  ></el-step>
                </el-steps>
              </div>

              <!--            账号验证-->
              <div v-if="step == 1">
                <div v-if="activeWay == 'mail'">
                  <el-form
                    ref="formMail"
                    :model="formMail"
                    :rules="rules"
                    label-position="left"
                    label-width="0px"
                    label-height="100px"
                  >
                    <el-form-item prop="mail">
                      <el-input
                        v-model="formMail.mail"
                        :placeholder="$t('common.pleaseInputEmail')"
                        auto-complete="off"
                      >
                        <template slot="prepend">{{
                          $t("common.email")
                        }}</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="passcode">
                      <el-input
                        type="text"
                        v-model="formMail.passcode"
                        auto-complete="off"
                        :placeholder="$t('common.pleaseInputVerificationCode')"
                      >
                        <el-button
                          v-if="formMail.sendCode"
                          @click.native="sendMessageMail"
                          slot="append"
                          >{{
                            $t("common.getEmailVerificationCode")
                          }}</el-button
                        >
                        <el-button
                          v-if="!formMail.sendCode"
                          slot="append"
                          style="width: 120px"
                          >{{ formMail.sendTime }}s{{
                            $t("common.sendAgain")
                          }}</el-button
                        >
                      </el-input>
                    </el-form-item>
                    <div class="me-button" @click="nextFuncMail01">
                      {{ $t("common.Next") }}
                    </div>
                  </el-form>
                </div>
                <div v-if="activeWay == 'phone'">
                  <el-form
                    ref="formMobile"
                    :model="formPhone"
                    :rules="rules"
                    label-position="left"
                    label-width="0px"
                    label-height="100px"
                  >
                    <el-form-item prop="mobile">
                      <el-input
                        v-model="formPhone.mobile"
                        :placeholder="$t('common.pleaseInputPhone')"
                        auto-complete="off"
                      >
                        <template slot="prepend">+86</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="passcode">
                      <el-input
                        type="text"
                        v-model="formPhone.passcode"
                        auto-complete="off"
                        :placeholder="$t('common.pleaseInputVerificationCode')"
                      >
                        <el-button
                          v-if="formPhone.sendCode"
                          @click.native="sendMessageMobile"
                          slot="append"
                          >{{
                            $t("common.getPhoneVerificationCode")
                          }}</el-button
                        >
                        <el-button
                          v-if="!formPhone.sendCode"
                          slot="append"
                          style="width: 120px"
                          >{{ formPhone.sendTime }}s{{
                            $t("common.sendAgain")
                          }}</el-button
                        >
                      </el-input>
                    </el-form-item>
                    <div class="me-button" @click="nextFuncPhone01">
                      {{ $t("common.Next") }}
                    </div>
                  </el-form>
                </div>
              </div>
              <!--       完成     -->
              <div class="sucess-out" v-if="step == '2'">
                <div class="sucess-img-out">
                  <div class="sucess-img"></div>
                  <span>{{ $t("msg.successMsg") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpTip from "@/components/tip/helpTip";
export default {
  components: {
    helpTip,
  },
  props: ["activeWay"], //mail  phone
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("common.passwordAgain")));
      } else if (value !== this.formPass.password) {
        callback(new Error(this.$t("common.passIsNotSame")));
      } else {
        callback();
      }
    };
    return {
      step: 1, //步骤
      formPass: {
        password: "",
        checkPass: "",
      },
      visibled: false,
      canGoIndex: false,
      formMail: {
        mail: "",
        passcode: "", //验证码
        sendCode: true,
        sendTime: 0,
      },
      formPhone: {
        mobile: "",
        passcode: "",
        sendCode: true,
        sendTime: 0,
      },
      rules: {
        mail: [
          {
            required: true,
            message: this.$t("common.NotNull"),
            trigger: "blur",
          },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: " ",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: this.$t("common.NotNull"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("msg.rightPhone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("common.enterpassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 18,
            pattern: /^[A-Za-z0-9]{6,18}$/,
            message: this.$t("common.pleaseInputPass"),
            trigger: "blur",
          },
        ],
        checkPass: [
          { validator: validatePass, trigger: "blur", required: true },
        ],
        passcode: [
          {
            required: true,
            message: this.$t("common.pleaseInputVerificationCode"),
            trigger: "blur",
          },
        ],
      },
      //页面使用的
      choseActive: "login", //login register
      // activeWay:'phone',
      remberpass: false,
      autologin: false,
      //验证码相关
      sendCode: true,
      sendTime: 0,
    };
  },
  methods: {
    resetStep() {
      this.step = 1;
    },
    changeFunc(val) {
      this.$emit("changeBinding", "false");
    },
    submitFormPass() {
      this.$refs.formPass.validate((valid) => {
        if (valid) {
          let form = {
            mobile: this.formPass.password,
          };

          this.step = 3;
          this.$api.login(form).then((res) => {
            if (res.success === true) {
              var token = res.datas.map.token;
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    againFunc() {
      alert(1);
    },
    nextFuncMail01() {
      this.$refs.formMail.validate((valid) => {
        if (valid) {
          let form = {
            email: this.formMail.mail,
            msgCode: this.formMail.passcode,
          };

          this.$api.CrBindEmailReq(form).then((res) => {
            if (res.code === "200") {
              this.step = 2;
              window.setTimeout(() => {
                location.reload();
              });
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
    nextFuncPhone01() {
      this.$refs.formMobile.validate((valid) => {
        if (valid) {
          let form = {
            phoneNumber: this.formPhone.mobile,
            msgCode: this.formPhone.passcode,
          };

          this.$api.bindingForPhone(form).then((res) => {
            if (res.code === "200") {
              this.step = 2;
              window.setTimeout(() => {
                location.reload();
              });
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
    //验证码相关
    sendMessageMail() {
      const reg =
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!reg.test(this.formMail.mail)) {
        this.$message({
          message: this.$t("msg.rightEmail"),
          type: "error",
        });
        return;
      }
      this.formMail.sendCode = false;
      this.formMail.sendTime = 60;
      var auth_timetimer = setInterval(() => {
        this.formMail.sendTime--;
        if (this.formMail.sendTime <= 0) {
          this.formMail.sendCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);

      this.$api
        .sendEmailVerificationCode({ email: this.formMail.mail }, "post")
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message: this.$t("msg.emailCodeSuccess"),
              type: "success",
            });
          } else {
            if (this.$i18n.locale == "en" && res.retMsgEn) {
              this.$message({
                message: res.retMsgEn,
                type: "error",
              });
            } else {
              this.$message({
                message: res.retMsg,
                type: "error",
              });
            }
          }
        });
    },
    sendMessageMobile() {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.formPhone.mobile)) {
        this.$message({
          message: this.$t("msg.rightPhone"),
          type: "error",
        });
        return;
      }
      this.formPhone.sendCode = false;
      this.formPhone.sendTime = 60;
      var timetimer = setInterval(() => {
        this.formPhone.sendTime--;
        if (this.formPhone.sendTime <= 0) {
          this.formPhone.sendCode = true;
          clearInterval(timetimer);
        }
      }, 1000);

      this.$api
        .sendPhoneVerificationCode(
          { phoneNumber: this.formPhone.mobile },
          "post"
        )
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message: this.$t("msg.smsSuccess"),
              type: "success",
            });
          } else {
            if (this.$i18n.locale == "en" && res.retMsgEn) {
              this.$message({
                message: res.retMsgEn,
                type: "error",
              });
            } else {
              this.$message({
                message: res.retMsg,
                type: "error",
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.helpTemplate {
  position: absolute;
  background: #fff;
  right: 10px;
  top: -20px;
}
//  pc
@media screen and (min-width: 900px) {
  .fd-out {
    display: flex;
    justify-content: center;
    align-items: center;
    .fd-in {
      width: 1000px;
      //height:700px;
      //margin-top: 67px;
      .title {
        height: 80px;
        .login-login {
          background: url(../../assets/login/logo2x.png) no-repeat center;
          height: 44px;
          width: 100px;
          background-size: 100% 100%;
        }
      }
      .fdinner {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: #fff;
        .innertit {
          width: 100%;
          height: 76px;
          background: #3774fe;
          border-radius: 8px 8px 0px 0px;
          line-height: 76px;
          color: #fff;
          text-align: center;
          font-size: 24px;
        }
        .device-type-fd-cla {
          width: 380px;
        }
      }
    }
  }
}
//android
@media screen and (max-width: 900px) {
  .fd-out {
    display: flex;
    justify-content: center;
    align-items: center;
    .fd-in {
      width: 100%;
      .title {
        height: 80px;
        .login-login {
          background: url(../../assets/login/logo2x.png) no-repeat center;
          height: 44px;
          width: 100px;
          background-size: 100% 100%;
        }
      }
      .fdinner {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: #fff;
        .innertit {
          width: 100%;
          height: 76px;
          background: #3774fe;
          //border-radius: 8px 8px 0px 0px;
          border-radius: 4px 4px 0px 0px;
          line-height: 76px;
          color: #fff;
          text-align: center;
          font-size: 24px;
        }
        .device-type-fd-cla {
          width: 100%;
        }
      }
    }
  }
}
.out-box-login {
  .buzhou-div {
    margin: 20px 0px;
  }
  .chose-way-out {
    justify-content: left;
    align-items: center;
    display: flex;
    margin: 16px 0;
    span {
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
      border-bottom: 2px solid rgba(0, 0, 0, 0);
    }
    span.active {
      color: #3774fe;
      border-bottom: 2px solid #3774fe;
    }
    .shu {
      background: #999;
      width: 1px;
      height: 10px;
      margin: 0 10px;
    }
  }
  .sucess-out {
    .sucess-img-out {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .sucess-img {
        margin-top: 20px;
        width: 100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/icon-sucess-mini.png) no-repeat
          center;
      }
      span {
        margin: 0 0 0 10px;
      }
    }
  }
  .me-button {
    border-radius: 2px;
    background: #3774fe;
    color: #fff;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 50px;
  }
  .little-btn-div {
    margin-top: 5px;
    .blue14 {
      cursor: pointer;
      color: #3774fe;
      font-size: 14px;
      float: right;
    }
  }
  .little-btn-divv2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 55px;
    margin-bottom: 20px;
    span {
      color: #ff625a;
      border: 1px solid #ff625a;
      margin-left: 5px;
      padding: 0 5px;
      cursor: pointer;
    }
  }
}

.loginpage {
  width: 100%;
  height: 100%;
  //background: url(../../assets/images/loginbg.jpg) no-repeat center;
  background-size: 100% 100%;
  background: #f4f4f5;
  position: relative;
}
</style>
<style>
.out-box-login .el-input__inner {
  height: 48px !important;
  line-height: 48px;
}
</style>
